const colors = {

    PRIMARY: '#4D96D9',
    PRIMARY_DARK: '#4585c0',
    PRIMARY_LIGHT: '#BCD7F1',
    INPUT_FEEDBACK: '#4A4A4A',
    SUCCESS: '#7fae1b',
    DANGER: '#F34336',
    PANEL_BORDER: '#C7D4DD',
    CHART_COLOR_1: '#89AB3B',
    CHART_COLOR_2: '#4D96D9',
    CHART_COLOR_3: '#FC9F5B',
    CHART_COLOR_4: '#4E4187',
    CHART_COLOR_5: '#E56399',
    CHART_COLOR_6: '#8D6346',
    CHART_COLOR_7: '#D7263D',
    CHART_COLOR_8: '#526760',
    CHART_COLOR_9: '#C9ADA1',
    CHART_COLOR_10: '#114B5F',
    CHART_COLOR_11: '#FFA5AB',
    CHART_COLOR_12: '#034C3C',
    CHART_COLOR_13: '#F49F0A',
    CHART_COLOR_14: '#3D0C11',
    CHART_COLOR_15: '#B0228C',
    CHART_COLOR_16: '#FE5F55',
    CHART_COLOR_17: '#B2C9AB',
    CHART_COLOR_18: '#26408B',
    CHART_COLOR_19: '#841C26',
    CHART_COLOR_20: '#63372C',
    CHART_COLOR_21: '#DABFFF',
    CHART_COLOR_22: '#84DCC6',
    CHART_COLOR_23: '#4B4E6D',
    CHART_COLOR_24: '#FDCA40',
    HEADER: '#1F3C57',
    SUBHEADER: '#2E5A82',
    PANEL_HEADER: '#737D89',
    BG_COLOR_2: '#EDF4FB',
    EVENT_COLOR: '#5F50A5',

}

const roles = {

    MEDICO: 'MEDICO_ROL',
    ASISTENTE: 'ASISTENTE_ROL',
    PACIENTE: 'PACIENTE_ROL',

}

module.exports = {
    colors,
    roles
}